import { useTranslation } from "react-i18next";
import {
  MonthOverviewActionContainer,
  MonthOverviewButtonsContainer,
  SalaryPageContainer,
} from "../salary.styled";
import { useState } from "react";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { EditWorkingHoursModal } from "../editWorkingHoursModal.component";
import { SalaryList } from "../salaryList.component";
import { WorkerDropdown } from "../workerDropDown.component";
import { CompanyWorker } from "model/Company";

export const MonthOverview = (): JSX.Element => {
  const { t } = useTranslation();
  const [editWorkingHours, setEditWorkingHours] = useState(false);
  const [selectedWorker, setSelectedWorker] = useState<CompanyWorker>();

  return (
    <SalaryPageContainer>
      <MonthOverviewActionContainer>
        <WorkerDropdown
          selectedWorker={selectedWorker}
          setSelectedWorker={setSelectedWorker}
          onlyActiveWorkers={false}
        />
        <MonthOverviewButtonsContainer>
          <PrimaryButton
            label={t("Salary.EditMonthHours")}
            onClick={() => setEditWorkingHours(true)}
            size="small"
          />
        </MonthOverviewButtonsContainer>
      </MonthOverviewActionContainer>
      {editWorkingHours && (
        <EditWorkingHoursModal
          setEditWorkingHours={setEditWorkingHours}
          editWorkingHours={editWorkingHours}
        />
      )}
      <SalaryList selectedWorker={selectedWorker?.id} />
    </SalaryPageContainer>
  );
};
